import React, { useMemo, useRef, useState } from "react";
import SectionShell from "./SectionShell";

export default function GalleryCarousel({ heading, images }) {
  const list = Array.isArray(images) ? images : [];
  const [idx, setIdx] = useState(0);

  const startX = useRef(null);
  const isDragging = useRef(false);

  const current = useMemo(() => list[idx] || null, [list, idx]);

  /* ===== EMPTY / SKELETON ===== */
  if (!list.length) {
    return (
      <div style={{ justifyContent:"center",display:'flex' }}>
        <SectionShell className="cl-gallery">
          {heading && <h2 className="cl-h2">{heading}</h2>}
          <div className="cl-gallerySkeleton">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="cl-skeleton cl-gallerySkeletonItem"
              />
            ))}
          </div>
        </SectionShell>
      </div>
    );
  }

  /* ===== SWIPE HANDLERS ===== */
  const onStart = (x) => {
    startX.current = x;
    isDragging.current = true;
  };

  const onMove = (x) => {
    if (!isDragging.current || startX.current == null) return;
    const delta = x - startX.current;

    if (Math.abs(delta) > 60) {
      if (delta < 0) {
        setIdx((prev) => (prev + 1) % list.length);
      } else {
        setIdx((prev) => (prev - 1 + list.length) % list.length);
      }
      isDragging.current = false;
      startX.current = null;
    }
  };

  const onEnd = () => {
    isDragging.current = false;
    startX.current = null;
  };

  return (
    <div style={{ justifyContent:"center",display:'flex' }}>
      <SectionShell className="cl-gallery">
        {heading && <h2 className="cl-h2">What To Expect</h2>}

        {/* ===== MAIN IMAGE FRAME ===== */}
        <div
          className="cl-galleryMain"
          onTouchStart={(e) => onStart(e.touches[0].clientX)}
          onTouchMove={(e) => onMove(e.touches[0].clientX)}
          onTouchEnd={onEnd}
          onMouseDown={(e) => onStart(e.clientX)}
          onMouseMove={(e) => isDragging.current && onMove(e.clientX)}
          onMouseUp={onEnd}
          onMouseLeave={onEnd}
        >
          <div className="cl-galleryMainInner">
            {current?.src && (
              <img
                src={current.src}
                alt={current.alt || ""}
                loading="lazy"
                draggable={false}
              />
            )}
          </div>
        </div>

        {/* ===== THUMBNAILS ===== */}
        <div className="cl-galleryThumbs">
          {list.map((img, i) => (
            <button
              key={i}
              className={`cl-galleryThumb ${i === idx ? "isActive" : ""}`}
              onClick={() => setIdx(i)}
              type="button"
              aria-label={`View image ${i + 1}`}
            >
              <img
                src={img.src}
                alt={img.alt || ""}
                loading="lazy"
                draggable={false}
              />
            </button>
          ))}
        </div>
      </SectionShell>
    </div>
  );
}
